import React, { Dispatch, SetStateAction, useContext } from 'react';

import { AppDataContext } from '../../context';
import type { CertificateDisplayItem, UserBadge } from '../../types';
import { useUserAchievements } from '../../hooks';
import BadgeDisplay from './BadgeDisplay';
import CertificateDisplay from './CertificateDisplay';

interface AchievementsProps {
  displayCertificates: boolean;
  setEnabled: Dispatch<SetStateAction<boolean>>;
}

const Achievements: React.FC<AchievementsProps> = ({ setEnabled, displayCertificates }) => {
  const { authenticatedUser } = useContext(AppDataContext);
  const { userCertificates, userBadges } = useUserAchievements({
    setEnabled,
    displayCertificates,
    username: authenticatedUser?.username || '',
  });

  if (displayCertificates) {
    return (
      <>
        {userCertificates.map((certificate: CertificateDisplayItem) => (
          <React.Fragment key={`achievement-cred-${certificate?.course_id}`}>
            <CertificateDisplay certificate={certificate} />
          </React.Fragment>
        ))}
      </>
    );
  }

  return (
    <>
      {userBadges.map((badge: UserBadge) => (
        <React.Fragment key={`achievement-cred-${badge?.title}`}>
          <BadgeDisplay badge={badge} />
        </React.Fragment>
      ))}
    </>
  );
};

export default Achievements;
